import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logo } from "../../assets/img";

const ReferPage = () => {
  const [referralData, setReferralData] = useState(null);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const { search } = useLocation();

  // Extract token from URL on mount
  useEffect(() => {
    const query = new URLSearchParams(search);
    const token = query.get("token");
    setReferralData(token);
  }, [search]);

  const handleJoinClick = () => {
    const deepLink = `vowuser://register?token=${referralData}`;
    if (deepLink.startsWith("vowuser://")) {
      window.location.href = deepLink;
    } else {
      window.open(deepLink, "_self");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.main}>
        <div>
          <img src={logo} className="nav-logo" alt="VOW Logo" />
          <h1 style={styles.h1}>Welcome to VOW</h1>
        </div>
        <p style={styles.p}>Join the most vibrant music app today!</p>

        <div style={styles.referralBox}>
          <div style={styles.referralLabel}>Your Referral Code</div>
          <div style={styles.referralCode}>
            {referralData ? (
              referralData
            ) : (
              <span style={styles.loading}>Generating...</span>
            )}
          </div>
        </div>

        <div style={styles.linkSection}>
          <h2 style={styles.h2}>Get Started</h2>
          <button
            style={{
              ...styles.primaryAction,
              ...(isRedirecting ? styles.primaryActionLoading : {}),
            }}
            onClick={handleJoinClick}
            disabled={!referralData || isRedirecting}
          >
            {isRedirecting ? "Redirecting..." : "✨ Join VOW NOW"}
          </button>
        </div>

        <div style={styles.footer}>
          <strong>How it works:</strong>
          <br />
          Click "Join VOW Now" to register with your referral code. Your friends
          will earn rewards when they use your code!
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    flex: 1,
  },
  main: {
    background: "white",
    padding: "30px",
    borderRadius: "16px",
    textAlign: "center",
    marginTop: "90px",
    maxWidth: "600px",
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.3)",
  },
  h1: {
    color: "#333",
    fontSize: "32px",
    marginBottom: "10px",
  },
  p: {
    color: "#666",
    fontSize: "16px",
    marginBottom: "20px",
  },
  referralBox: {
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    padding: "20px",
    borderRadius: "12px",
    margin: "30px 0",
  },
  referralLabel: {
    fontSize: "14px",
    opacity: 0.9,
    marginBottom: "8px",
  },
  referralCode: {
    fontSize: "28px",
    fontWeight: "bold",
    letterSpacing: "2px",
    fontFamily: '"Courier New", monospace',
    minHeight: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    wordBreak: "break-all",
  },
  loading: {
    color: "#ccc",
    fontSize: "18px",
  },
  linkSection: {
    margin: "20px 0",
  },
  h2: {
    fontSize: "18px",
    color: "#333",
    marginBottom: "15px",
    fontWeight: 600,
  },
  primaryAction: {
    display: "inline-block",
    background: "#34c759",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "16px",
    padding: "14px 28px",
    marginTop: "20px",
    cursor: "pointer",
    transition: "opacity 0.3s",
  },
  primaryActionLoading: {
    background: "#7cb342",
    opacity: 0.7,
    cursor: "not-allowed",
  },
  footer: {
    marginTop: "30px",
    borderTop: "2px solid #eee",
    paddingTop: "20px",
    fontSize: "13px",
    color: "#666",
    lineHeight: 1.6,
  },
};

export default ReferPage;
